import React, { useState, useEffect } from "react";
import "./termsOfUse.css";
import { Table } from "antd";
import { editIcon } from "../../assets";

import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import { RedNotify } from "../../helper/helper";
import LegalDocModal from "../../components/legalDocModal/LegalDocModal";
import Loader from "../../components/loader/loader";
import PageHeader from "../../components/pageHeader/PageHeader";

const documentConfig = {
  title: "Terms of Use",
  field: "terms",
  collectionName: "legal_documents",
};

const documentTypes = {
  PRIVACY_POLICY: {
    id: "0",
    title: "Privacy Policy",
    field: "policy",
    collectionName: "legal_documents",
  },
  TERMS_CONDITIONS: {
    id: "1",
    title: "Terms & Conditions",
    field: "terms",
    collectionName: "legal_documents",
  },
  ABOUT_US: {
    id: "1",
    title: "About Us",
    field: "aboutUs",
    collectionName: "legal_documents",
  },
};
const TermsOfUse = ({ documentType = "terms_use" }) => {
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [document, setDocument] = useState(null);
  const [documents, setDocuments] = useState([]);

  const fetchDocuments = async () => {
    try {
      setLoading(true);
      const querySnapshot = await getDocs(collection(db, "legal_documents"));

      if (querySnapshot.empty) {
        console.log(`No  document found.`);
        RedNotify(`No document found.`);
        return;
      }

      const docs = querySnapshot.docs.map((doc) => ({
        _id: doc.id,
        ...doc.data(),
      }));

      console.log(docs);
      setDocuments(docs);
      setDocument(docs[2]); // Use the first document
    } catch (error) {
      console.error(`Error fetching:`, error);
      RedNotify(error.message);
    } finally {
      setLoading(false);
    }
  };
  const currentDocConfig = documentTypes[documentType];
  useEffect(() => {
    fetchDocuments();
  }, []);

  const handleEditClick = () => {
    setShowModal(true);
  };

  const tableItems = document
    ? [
        {
          key: document.id,
          content: document[documentConfig.field] || "",
        },
      ]
    : [];

  const columns = [
    {
      title: "Description",
      dataIndex: "content",
      align: "center",
      className: "action-column-header",
      render: (text) => (
        <div
          dangerouslySetInnerHTML={{ __html: text }}
          className="terms-content"
        />
      ),
    },
    {
      title: "Edit",
      dataIndex: "edit",
      align: "center",
      className: "action-column-header",
      render: () => (
        <div onClick={handleEditClick} className="edit-icon-container">
          <img src={editIcon} alt="Edit" />
        </div>
      ),
    },
  ];

  return (
    <div className="admin-terms-main-container">
      {showModal && (
        <LegalDocModal
          showModal={showModal}
          setShowModal={setShowModal}
          item={document} // Pass the entire document object
          id={"2"}
          // data={documents}

          refreshData={fetchDocuments} // Pass the refresh function
        />
      )}

      <Loader loading={loading} />
      <PageHeader
        eyebrow="Legal"
        title={documentConfig.title}
        subtitle="The terms of use presented to users in the 2nd Home app. Use the edit action to update its content."
      />

      <div className="server-roles-tb-main-container">
        <Table
          columns={columns}
          dataSource={tableItems}
          pagination={false}
          className="terms-table"
          rowKey="key"
        />
      </div>
    </div>
  );
};

export default TermsOfUse;
